/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import registerServiceWorker from './config/registerServiceWorker';
import App from './views/App';
import './theme/styles/bootstrap/css/bootstrap.css';
import './theme/styles/index.css';
//import './theme/iconFont/HSBCIcon-Font.css';
import IntlProvider from './shared/containers/IntlProvider';

import { loadLanguage, setHtmlLang } from './utils';

const selectedLanguage = loadLanguage()
setHtmlLang(selectedLanguage)
const initialState = {
    app : {
        selectedLanguage,
        isLoading: false
    }
}

const store = configureStore(initialState);
// console.log = (props) => {}

require('intl')
render(
    <Provider store={store}>
        <IntlProvider locale="en">
            <App />
        </IntlProvider>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js